import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (replaces render-blocking Google Fonts CDN; also lets the
// CSP drop third-party font origins and avoids shipping visitor IPs to Google).
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import './index.css';
import App from './App';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Core Web Vitals — local dev logging only.
// No GA/GTM in v3 (keeps the site cookie-banner-free per PRD §10.3 / §14.1).
function reportWebVital(metric) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('Web Vital:', metric);
  }
}

getCLS(reportWebVital);
getFID(reportWebVital);
getFCP(reportWebVital);
getLCP(reportWebVital);
getTTFB(reportWebVital);
